import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { announceConnectResult, connectMessage } from "../lib/youtube";

/**
 * /youtube/done: where the connect window lands after Google's page (lib/youtube.ts
 * openYoutubeConnect). It tells the page that opened it the result and closes; a browser that keeps
 * it open (a tab the user opened by hand) shows the result and the way back.
 */
export default function YoutubeDone() {
  const [params] = useSearchParams();
  const result = params.get("youtube") ?? "error";
  const [open, setOpen] = useState(false);
  useEffect(() => {
    announceConnectResult(result);
    // a moment for the message to reach the opener before the window goes
    const close = setTimeout(() => window.close(), 150);
    const t = setTimeout(() => setOpen(true), 600);
    return () => {
      clearTimeout(close);
      clearTimeout(t);
    };
  }, [result]);
  return (
    <div className="p" style={{ paddingTop: 48, maxWidth: 560 }} data-testid="yt-done" data-result={result}>
      <h2>{connectMessage(result)}</h2>
      {open && <p className="sub mt10">You can close this window. <a className="u" href="/">Back to Deep Third</a></p>}
    </div>
  );
}
